import { render } from "./pilot-nav.vue?vue&type=template&id=6db6b91e&scoped=true"
import script from "./pilot-nav.vue?vue&type=script&lang=js"
export * from "./pilot-nav.vue?vue&type=script&lang=js"

import "./pilot-nav.vue?vue&type=style&index=0&id=6db6b91e&scoped=true&lang=scss"

import exportComponent from "E:\\my-work\\company\\product\\LessonPlay\\lessonplay_shell\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6db6b91e"]])

export default __exports__